<!-- <div *ngIf="woOrder.scUserId" class="col-12 text-xl"> -->
<div class="col-12 text-xl">

    <div class="formgrid grid">
        <div *ngIf="!woOrder?.id" class="field col-12 md:col-6 lg:col-4 xl:col-4">
            <!-- <p-dropdown [(options)]="listUser" [(ngModel)]="selectedUser" optionLabel="name" [filter]="true" filterBy="name"
                [showClear]="true" [placeholder]="'Selecione o Usuário'" (onChange)="onChangerUser($event.value)" [style]="{'width':'100%'}" appendTo="body">
            </p-dropdown> -->

            <p-dataView #dv [value]="listUser" [style]="{ width: '100%', 'max-height': '400px', 'overflow-y': 'scroll' }" [loading]="loadingUser">
                <ng-template pTemplate="list" let-user>
                    <div class="grid grid-nogutter">
                        <div class="card col-12" *ngFor="let item of user; let first = first"
                            style="border-radius: 16px !important; border: 1px solid #d1c6c6; cursor: pointer;"
                            [style]="{ 'background-color': selectedUser && selectedUser.id === item.id ? '#e0f7fa' : '' }"
                            (click)="onChangerUser(item)">
                            <div class="flex flex-column sm:flex-row sm:align-items-center p-2 gap-2">
                                <div class="md:w-5rem relative">
                                    <div class="image-container"
                                        [ngStyle]="{backgroundImage: 'url(assets/layout/images/perfil.svg)'}"
                                        *ngIf="!item.pictureUri"></div>
                                    <img *ngIf="item.pictureUri" class="image-container" [src]="item.pictureUri"
                                        [alt]="item.name" style="border-radius: 32px !important;" />
                                </div>
                                <div
                                    class="flex flex-column md:flex-row justify-content-between md:align-items-center flex-1 gap-4">
                                    <div
                                        class="flex flex-row md:flex-column justify-content-between align-items-start gap-2">
                                        <div>
                                            <span class="text-lg font-medium text-900">{{ item.name }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>
                <ng-template pTemplate="empty">
                    <div *ngIf="listUser?.length == 0" class="col-12 text-center">
                        <span translate>Carregando...</span>
                    </div>
                </ng-template>
            </p-dataView>

        </div>

        <div class="field col-12 md:col-6 lg:col-8 xl:col-8">
            <div class="field col-12">
                <label for="message" class="font-medium hidden md:block text-2xl">
                    <span translate>message.send_message</span> {{ isClient ? userName : clientName }}
                </label>
                <textarea rows="5" cols="30" pInputTextarea id="message" [(ngModel)]="message" [disabled]="false"
                    tabindex="1"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"></textarea>
            </div>
            <div class="field col-12 mt-5">
                <div class="grid">
                    <div class="col">
                        <div class="text-right">
                            <button pButton pRipple icon="pi pi-times" style="width: 150px; margin: 3px;"
                                class="text-xl font-semibold p-button-outlined" size="large"
                                [label]="'button.cancel' | translate" (click)="cancel();">
                            </button>
                            <button pButton pRipple [disabled]="!message || (!selectedUser && !woOrder.scUserId)"
                                icon="pi pi-save" style="width: 150px; margin: 3px;" class="text-xl font-semibold ml-3"
                                [label]="'button.save' | translate" (click)="save();">
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>